import { IParamsGetRefererReport } from "app/api/marketing/referer-report/model";

export const RefererReportKeys = {
  allRefererReports: ['RefererReports'] as const,
  listRefererReport: () =>
    [...RefererReportKeys.allRefererReports, 'RefererReports'] as const,
  listRefererReports: (filter?: IParamsGetRefererReport) =>
    [...RefererReportKeys.listRefererReport(), { filter }] as const,
}
